import React from 'react';
import { ActivityIndicator, Pressable, PressableProps, Text, View } from 'react-native';

import { ButtonProps, SIZES } from '.';

import { getIconByName } from 'components/Icons';

type SolidButtonProps = Omit<ButtonProps, 'gradientVariant' | 'variant'>;

const SolidButton = React.forwardRef<PressableProps, SolidButtonProps>(
  (
    {
      backgroundColor = '#1240ff',
      children,
      iconStyle,
      iconType,
      isFullWidth = false,
      isLoading = false,
      size = 'md',
      style,
      textStyle,
      textTransform,
      rounded = false,
      ...rest
    },
    ref
  ) => {
    const Icon = iconType ? getIconByName(iconType) : null;
    return (
      <Pressable
        role="buton"
        ref={ref}
        style={[
          {
            backgroundColor,
            width: isFullWidth ? '100%' : undefined,
            paddingHorizontal: 20,
          },
          style,
        ]}
        {...rest}>
        {Icon && (
          <View style={{ marginRight: 4 }}>
            <Icon {...iconStyle} />
          </View>
        )}
        {children && (
          <Text
            style={[
              {
                color: 'white',
                fontFamily: 'system-ui',
                fontSize: SIZES[size],
                textTransform,
              },
              textStyle,
            ]}>
            {children}
          </Text>
        )}
        {isLoading && <ActivityIndicator color="white" size="small" style={{ marginLeft: 4 }} />}
      </Pressable>
    );
  }
);

export default SolidButton;
